import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_182: DocMigration = {
  maxSchemaVersion: "0.0.182",
  description: "Migrate opening patterns to new openings table",
  apply(json: any) {
    const openings = {};

    let solidWallCount = 0;
    let voidWallCount = 0;
    let doorCount = 0;
    let windowCount = 0;
    let openingSortIndex = -1;

    const entityGroups = json.entityGroups || {};
    const groups = json.groups || {};

    for (const roomLayoutId in json.roomLayouts) {
      const roomLayout = json.roomLayouts[roomLayoutId];
      if (roomLayout.openingPatterns) {
        for (const openingPattern of roomLayout.openingPatterns) {
          const wallStripDomain = openingPattern.wallStripDomain;
          const edgeId = openingPattern.edgeId;

          const groupId = uid();
          const minSortIndex = openingSortIndex + 1;

          if (!openingPattern.openings || openingPattern.openings.length === 0) {
            solidWallCount++;
            openingSortIndex++;

            const id = uid();
            openings[id] = {
              name: "Solid Wall " + solidWallCount,
              sortIndex: undefined,
              type: "SOLID",
              entityType: "OPENING",
              id,
              parentId: roomLayoutId,
              edgeId,
              wallStripDomain,
            };

            entityGroups[`opening.${id}`] = groupId;

            groups[groupId] = {
              id: groupId,
              disabled: openingPattern.disabled,
              sortIndex: minSortIndex,
              name: openingPattern.name || "Solid Wall Group " + solidWallCount,
              entityType: "GROUP",
              exclusive: true,
            };

            continue;
          }

          if (
            openingPattern.openings.length === 1 &&
            openingPattern.openings[0].type === "DOOR" &&
            openingPattern.openings[0].doorType === "OPEN_FULL"
          ) {
            openingSortIndex++;
            voidWallCount++;
            const id = uid();

            openings[id] = {
              ...openingPattern.openings[0],
              name: openingPattern.openings[0].name || "Void Wall " + voidWallCount,
              entityType: "OPENING",
              sortIndex: openingSortIndex,
              id,
              parentId: roomLayoutId,
              edgeId,
              wallStripDomain,
            };

            entityGroups[`opening.${id}`] = groupId;

            groups[groupId] = {
              id: groupId,
              disabled: openingPattern.disabled,
              sortIndex: minSortIndex,
              name: openingPattern.name || "Void Wall Group " + voidWallCount,
              entityType: "GROUP",
              exclusive: true,
            };

            continue;
          }

          let openingPatternHasAtLeastOneConditionalChild = false;

          for (const opening of openingPattern.openings) {
            openingSortIndex++;
            const id = uid();

            let name: string;
            if (opening.type === "DOOR") {
              doorCount++;
              name = "Door " + doorCount;
            } else {
              windowCount++;
              name = "Window" + windowCount;
            }

            if (isFormula(opening.disabled)) {
              openingPatternHasAtLeastOneConditionalChild = true;
            }

            openings[id] = {
              ...opening,
              name: opening.name ?? name,
              entityType: "OPENING",
              sortIndex: openingSortIndex,
              id,
              parentId: roomLayoutId,
              edgeId,
              wallStripDomain,
            };
            entityGroups[`opening.${id}`] = groupId;
          }

          if (openingPatternHasAtLeastOneConditionalChild) {
            const id = uid();
            openings[id] = {
              name: "Solid Wall " + solidWallCount,
              sortIndex: undefined,
              type: "SOLID",
              entityType: "OPENING",
              id,
              parentId: roomLayoutId,
              edgeId,
              wallStripDomain,
            };
            entityGroups[`opening.${id}`] = groupId;
          }

          groups[groupId] = {
            id: groupId,
            disabled: openingPattern.disabled,
            sortIndex: minSortIndex,
            name: openingPattern.name || "Untitled Group",
            entityType: "GROUP",
            exclusive: true,
          };
        }
      }

      delete roomLayout.openingPatterns;
    }
    json.openings = openings;
    json.groups = groups;
    json.entityGroups = entityGroups;

    return json;
  },
};

export default migration_0_0_182;

function isFormula(v: any) {
  return !!v && typeof v === "object" && v.hasOwnProperty("type") && v.type === "FORMULA";
}
